export type ActivityKindFilter =
  | "all"
  | "state"
  | "comment"
  | "assigned"
  | "linked";

export type ActivityActorFilter = "all" | "user" | "cli" | "tracker" | "run";

export interface ProjectActivityEntry {
  id: string;
  kind: string;
  actorKind: string;
  actorId: string | null;
  actorName: string | null;
  canonicalFindingId: string;
  canonicalTitle: string | null;
  fromState: string | null;
  toState: string | null;
  reason: string | null;
  body: string | null;
  payload: Record<string, unknown> | null;
  walkthroughId: string | null;
  createdAt: string;
}

export interface ActivityGroup {
  label: string;
  entries: ProjectActivityEntry[];
}

export function groupEntriesByDate(
  entries: ProjectActivityEntry[],
): ActivityGroup[] {
  const now = new Date();
  const startOfToday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
  ).getTime();
  const startOfYesterday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() - 1,
  ).getTime();
  const startOfSevenDaysAgo = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() - 7,
  ).getTime();

  const groups: Record<string, ProjectActivityEntry[]> = {
    Today: [],
    Yesterday: [],
    "Earlier this week": [],
    Older: [],
  };

  for (const entry of entries) {
    const time = new Date(entry.createdAt).getTime();
    if (time >= startOfToday) {
      groups.Today.push(entry);
    } else if (time >= startOfYesterday) {
      groups.Yesterday.push(entry);
    } else if (time >= startOfSevenDaysAgo) {
      groups["Earlier this week"].push(entry);
    } else {
      groups.Older.push(entry);
    }
  }

  return (["Today", "Yesterday", "Earlier this week", "Older"] as const)
    .filter((label) => groups[label].length > 0)
    .map((label) => ({
      label,
      entries: groups[label],
    }));
}
